/* eslint-disable immutable/no-mutation,no-nested-ternary */
import camelize from 'camelize';
import get from 'lodash/get';
import last from 'lodash/last';
import size from 'lodash/size';
import uniqBy from 'lodash/uniqBy';

import { NOTIFICATION_TYPES } from '../../../constants/chat';

const EXCLUDED_FOR_PROVIDER_NOTIFICATIONS = [
  NOTIFICATION_TYPES.UPCOMING_SURVEY,
  NOTIFICATION_TYPES.ASSIGN_TO_PROGRAM,
  NOTIFICATION_TYPES.REMOVE_FROM_PROGRAM,
  NOTIFICATION_TYPES.PROVIDER_ASSIGNED,
  NOTIFICATION_TYPES.PROVIDER_REMOVED,
];

export default class CircleOfCareChannel {
  constructor(
    channelId,
    { emit, push },
    { userId, unreadCount = 0, lastMessageAt, isProvider },
  ) {
    // data
    this.channelId = channelId;
    this.isProvider = isProvider;
    this.currentPage = 0;
    this.messages = [];
    this.unreadCount = unreadCount;
    this.lastMessageAt = lastMessageAt;
    this.userId = userId;
    this.masterUserId = null;
    this.totalPages = 0;
    this.inboxTaskId = null;

    // actions
    this.emit = emit;
    this.push = push;

    // update lastMessageAt channel data for empty initialized channels
    if (lastMessageAt) {
      this.emit('conversation_changed', this);
    }
  }

  getMessages() {
    return this.messages;
  }

  sendMessage({
    message,
    important,
    quoteMessageId,
    linkPayload,
    inboxTaskId,
  }) {
    this.push('conversations:send_message', {
      channel_id: this.channelId,
      important,
      message,
      quote_message_id: quoteMessageId,
      link_payload: linkPayload,
      inbox_task_id: inboxTaskId,
    });
  }

  bumpActivity() {
    this.unreadCount = 0;
    this.push('conversations:bump_activity', {
      channel_id: this.channelId,
    });
    this.emit('bump_activity', this);
  }

  loadNextHistoryPage() {
    this.push('conversations:paginated_history', {
      channel_id: this.channelId,
      page: this.currentPage + 1,
    }).receive('ok', response => this._loadHistory(response));
  }

  setUnreadCount(unreadCount) {
    this.unreadCount = unreadCount;
  }

  setMasterUserId(id) {
    this.masterUserId = id;
  }

  _onRecieveRemoveMessages(data) {
    const ids = data.ids.map(Number);

    const { unchanged, removed } = this.messages.reduce(
      (acc, msg) => {
        const type = ids.includes(msg.id) ? 'removed' : 'unchanged';
        acc[type].push(msg);

        return acc;
      },
      { unchanged: [], removed: [] },
    );

    this.messages = unchanged;
    // decrease counters on message delete event
    // this.unreadCount = get(data, 'unreadCount', this.unreadCount);
    this.lastMessageAt = get(last(this.messages), 'insertedAt');

    this.emit('remove_messages', { channel: this, removed });
  }

  _onRecieveNewMessage(data) {
    const isLoggedUserMessage = this.userId === get(data, 'message.authorUid');
    const notificationType = get(data, 'message.payload.data.type');
    const excludeNotifications =
      this.isProvider &&
      EXCLUDED_FOR_PROVIDER_NOTIFICATIONS.includes(notificationType);
    const hasTriggeredMessage =
      size(get(data, 'message.payload.data.triggerMessages')) > 0;
    const excludedCompletedSurvey =
      this.isProvider &&
      notificationType === NOTIFICATION_TYPES.ANSWERED_SURVEY &&
      !hasTriggeredMessage;

    if (
      !isLoggedUserMessage &&
      !excludeNotifications &&
      !excludedCompletedSurvey
    ) {
      // increase counters on new message event
      this.unreadCount++;
    }
    this.messages.push(data.message);
    this.lastMessageAt = get(data.message, 'insertedAt');
    this.masterUserId = get(data, 'message.masterUserId');
    this.inboxTaskId = get(data, 'message.inboxTaskId');

    this.emit('conversation_changed', this);
  }

  _loadHistory(response) {
    this.currentPage++;
    this.totalPages = get(response.messages, 'total_pages');
    const entries = get(response, 'messages.entries', []);
    this.messages = camelize(entries).concat(this.messages);
    this.messages = uniqBy(this.messages, 'id');
    this._sortAllMessages();
    this.emit('conversation_changed', this);
  }

  _sortAllMessages() {
    const sortById = (a, b) => (a.id < b.id ? -1 : a.id > b.id ? 1 : 0);

    this.messages = this.messages.sort(sortById);
  }
}



// WEBPACK FOOTER //
// ./src/utils/chatAPI/channels/circle_of_care_channel.js